
class Generator {
    
    randomInt(min:number, max:number) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
      }

    randomList(array:any[]) {
      array.sort(this.shuffle)
      return array
    }

    private shuffle(){
      return (0.5 - Math.random())
    }
}

export default Generator